"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncReportGranularityToJSON = exports.AsyncReportGranularityFromJSONTyped = exports.AsyncReportGranularityFromJSON = exports.AsyncReportGranularity = void 0;
/**
 * Reporting granularity for time breakdowns. Supported values are LIFETIME and DAY.
 * For DAY, each row of the report for the primary entity will contain time series
 * data within the range of report_start and report_end broken down by day.
 *
 * @export
 */
exports.AsyncReportGranularity = {
    Day: 'DAY',
    Lifetime: 'LIFETIME'
};
function AsyncReportGranularityFromJSON(json) {
    return AsyncReportGranularityFromJSONTyped(json, false);
}
exports.AsyncReportGranularityFromJSON = AsyncReportGranularityFromJSON;
function AsyncReportGranularityFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AsyncReportGranularityFromJSONTyped = AsyncReportGranularityFromJSONTyped;
function AsyncReportGranularityToJSON(value) {
    return value;
}
exports.AsyncReportGranularityToJSON = AsyncReportGranularityToJSON;
